"use strict";

import PageProcessor from '../PageProcessor.js';

export default class InformationPage extends PageProcessor {

	constructor()
	{
		super();
		this.displayType = 'information';
		this.setPageType('information');
		this.setActive(true);
	}

	/**
	 * Initialize processor
	 * @return
	 */
	initialize() 
	{
		let self = this;

		self.bindElements(self.settings);

		if (!self.readyForAttach()) {
			self.debug("Not ready for attach, returning...");
			return;
		}

		self.getContent()
			.then(content => {
				self.attachContent(content.style, content.html)
					.then(() => self.afterAttachment(content.script));
			});

		if (!self.hasBeenInitialized) {
			self.hasBeenInitialized = true;

			self.appendCustomCssToHead(self.settings.display.customCSS);
			self.runScript(self.settings.display.customJS);
		}
	}

	/**
	 * Bind elements
	 * @param  {Object} settings
	 * @return
	 */
	bindElements(settings) {
		this.elementBinding.addElements({
			"insertContainer": settings.display.insertContainer,
			"sparxpresContent": "." + this.getWrapperClass()
		});
	}

	/**
	 * Get content from content service
	 * @return {Promise|null}
	 */
	getContent() {
		const params = {
			"linkId": this.linkId,
			"sb": !!+this.settings.general.hasCheckout ? 0 : 1
		};

		return this.contentService.getInformationContent(params);
	}

}
